import { Heading } from 'components/base';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { cover, item, itemBg, text, textBg, title as titleC } from './CaseIndexItem.module.scss';

const Item = ({ title, coverImage, slug, company }) => (
  <Link to={slug} className={item}>
    <div className={cover}>
      { coverImage.publicURL && <img src={coverImage.publicURL} alt={title} /> }
      <span className={titleC}>
        <h4 className={text}>{title}</h4>
        <span className={textBg}></span>
        <svg className={itemBg} width="332px" height="232px" viewBox="0 0 332 232" version="1.1">
          <path d="M0,165.825007 C15.5299081,110.839799 54.2775339,67.4128013 116.242877,35.5440126 C178.208221,3.67522388 250.127262,-6.76337969 332,4.22820188 L332,232 L0,231 L0,165.825007 Z" fill="#3B529F"></path>
        </svg>
      </span>
    </div>
    <Heading Tag="h3" size="SM" bold center>
      {company.displayName}
    </Heading>
  </Link>
);

Item.propTypes = {
  title: PropTypes.string,
  coverImage: PropTypes.object,
  slug: PropTypes.string,
  company: PropTypes.object,
};

export default Item;